<template>
  <div class="aws-sku-spec-descriptions">
    <div class="aws-sku-spec-descriptions-image">
      <div class="aws-sku-spec-descriptions-image-inner">
        <el-image :src="displayImage" :preview-src-list="[displayImage]" />
      </div>
    </div>

    <div class="aws-sku-spec-descriptions-info">
      <div class="descriptions">
        <el-row class="descriptions-row">
          <el-col :span="6" class="descriptions-item">
            <div class="descriptions-label">规格编号</div>
            <div class="descriptions-content">
              {{ data.specNo || '' }}
            </div>
          </el-col>
          <el-col :span="6" class="descriptions-item">
            <div class="descriptions-label">NC编号</div>
            <div class="descriptions-content">
              {{ data.specNcNo || '' }}
            </div>
          </el-col>
          <el-col :span="12" class="descriptions-item">
            <div class="descriptions-label">更新时间</div>
            <div class="descriptions-content">
              {{ displayModify }}
            </div>
          </el-col>
        </el-row>

        <el-row class="descriptions-row">
          <el-col :span="12" class="descriptions-item">
            <div class="descriptions-label">规格名称</div>
            <div class="descriptions-content">
              {{ data.specName || '' }}
            </div>
          </el-col>
          <el-col :span="12" class="descriptions-item">
            <div class="descriptions-label">英文名称</div>
            <div class="descriptions-content">
              {{ data.specNameEn || '' }}
            </div>
          </el-col>
        </el-row>

        <el-row class="descriptions-row">
          <el-col :span="12" class="descriptions-item">
            <div class="descriptions-label">规格尺寸</div>
            <div class="descriptions-content">
              {{ data.displaySpec || '' }}
            </div>
          </el-col>
          <el-col :span="6" class="descriptions-item">
            <div class="descriptions-label">规格数量</div>
            <div class="descriptions-content">
              {{ data.specQty || 0 }}
            </div>
          </el-col>
          <el-col :span="6" class="descriptions-item">
            <div class="descriptions-label">功能操作</div>
            <div class="descriptions-content descriptions-buttons">
              <el-tooltip
                v-if="buttons.includes('edit')"
                effect="dark"
                :content="$l('INDEX.btn_editAwsSkuProductSpec') || '编辑规格'"
                placement="top"
              >
                <i class="el-icon-edit tool-btn" @click="$emit('edit')" />
              </el-tooltip>

              <el-tooltip
                v-if="buttons.includes('remove')"
                effect="dark"
                :content="$l('INDEX.btn_removeAwsSkuProductSpec') || '删除规格'"
                placement="top"
              >
                <i
                  class="el-icon-delete tool-btn "
                  style="color: red;"
                  @click="$emit('remove')"
                />
              </el-tooltip>

              <el-tooltip
                v-if="buttons.includes('editImage')"
                effect="dark"
                :content="
                  $l('INDEX.btn_awsSkuProductSpecEditImage') || '编辑图片'
                "
                placement="top"
              >
                <i
                  class="el-icon-picture-outline tool-btn"
                  @click="$emit('editImage')"
                />
              </el-tooltip>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: { type: Object, default: () => {} },
    buttons: { type: Array, default: () => ['edit', 'remove', 'editImage'] },
  },
  computed: {
    displayImage() {
      const { defaultImageUrl } = this.data
      return (
        this.$osscdn(defaultImageUrl) || '/image/static/img/nopic-square.jpg'
      )
    },
    displayModify() {
      const { modifyByName, modifyDate } = this.data
      return [modifyByName, modifyDate].filter(Boolean).join(' at ')
    },
  },
}
</script>

<style lang="scss" scoped>
.aws-sku-spec-descriptions {
  display: flex;
  align-items: stretch;
  flex-direction: row;
  .aws-sku-spec-descriptions-image {
    padding: 8px;
    border: 1px solid #ebeef5;
    border-right: none;
    display: flex;
    align-items: center;

    .aws-sku-spec-descriptions-image-inner {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 8px;
      border-radius: 5px;
      border: 1px dashed #cecece;

      .el-image {
        width: 90px;
        height: 90px;
        border-radius: 5px;
      }
    }
  }

  .aws-sku-spec-descriptions-info {
    flex-grow: 1;
  }
}

.descriptions {
  --padding: 10px 12px;

  --border-width: 1px;
  --border-style: solid;
  --border-color: #ebeef5;

  --label-width: 110px;
  --label-bg: #f5f7fa;

  border-width: var(--border-width);
  border-color: var(--border-color);
  border-left-style: var(--border-style);
  border-bottom-style: var(--border-style);

  .descriptions-row {
    display: flex;
    align-items: stretch;
    .descriptions-item {
      display: flex;
      align-items: stretch;
      flex-direction: row;
      .descriptions-label {
        font-size: 14px;
        color: #909399;
        width: var(--label-width);
        min-width: var(--label-width);
        padding: var(--padding);
        border-width: var(--border-width);
        border-color: var(--border-color);
        border-top-style: var(--border-style);
        border-right-style: var(--border-style);
        background-color: var(--label-bg);
      }

      .descriptions-content {
        flex-grow: 1;
        font-size: 14px;
        color: #606266;
        padding: var(--padding);
        border-width: var(--border-width);
        border-color: var(--border-color);
        border-top-style: var(--border-style);
        border-right-style: var(--border-style);
        word-break: break-all;
      }
    }
  }

  .descriptions-buttons {
    padding: 0 12px !important;
    display: flex;
    align-items: center;
    gap: 8px;
  }
}
</style>
